export const ID = 'd0ac12d1-bacd-4cef-bd5a-db741ead96ef';

export const NAME = 'Google Map: All Facilities';
